































































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css';

import VideoBox from './Video.vue';
import VideoBox2 from './Video2.vue';

let vm: any = null;


@Component({
  components: {
    VideoBox,
    VideoBox2,
    Swiper,
    SwiperSlide
  },
  directives: {
    swiper: directive
  }
})
export default class Home extends Vue {

  private active = 1;

  private ico = 'ico1';

  private tit = '动画剧场';
  private desc = '沉浸式情景学习体验备份';

  private created() {
    vm = this;
  }

  private swiperOptions: any =  {
    pagination: {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    },
    loop: true,
    width: 720,
    height: 450,
    on: {
      slideChangeTransitionEnd: function(){
        const activeIndex: number = (this as any).activeIndex as number;
        vm.active = activeIndex;
        vm.ico = 'ico' + activeIndex;
      },
    },
  }

  private next() {
    this.swiper.slideNext();
  }

  private pre() {
    this.swiper.slidePrev();
  }

  get swiper(): any {
    return (this.$refs.mySwiper as any).$swiper;
  }

  @Watch('active')
  private setDesc() {
    if (this.active === 1) {
      this.tit = '动画剧场';
      this.desc = '沉浸式情景学习体验备份';
    } else if (this.active === 2) {
      this.tit = '口语评测';
      this.desc = 'AI智能跟读评测打分';
    } else if (this.active === 3) {
      this.tit = '魔法课堂';
      this.desc = '重难点讲解 同步巩固练习';
    } else if (this.active === 4) {
      this.tit = '激励体系';
      this.desc = '互动能量激励 智能学习报告';
    } else {
      this.tit = '动画剧场';
      this.desc = '沉浸式情景学习体验备份';
    }
  }

}
